import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import useAxios from 'src/hooks/use-axios';
import { useAuth } from 'src/hooks/use-auth';
import { useUser } from 'src/hooks/use-user';

function RequireAuth({ element }) {
  const id = element?.props.id;
  const { user, setUser } = useUser();
  const location = useLocation();
  const { auth } = useAuth();
  const api = useAxios();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      let profile;
      try {
        profile = (await api.get('/v1/users/profile/')).data;

        if (profile.organization_id) {
          const organization = (await api.get(`/v1/organizations/${profile.organization_id}/`)).data;
          profile = { ...profile, organization };
        }
      } catch (err) {
        console.log(err);
      } finally {
        setUser(profile);
        setIsLoading(false);
      }
    };

    if (auth) fetchUserProfile();
  }, [api, auth, setUser]);

  const hasAccess = user?.access.includes(id);

  const redirectPath =
    location.pathname !== '/' ? `?next=${encodeURIComponent(location.pathname + location.search)}` : '';

  if (!auth) return <Navigate to={`/login/${redirectPath}`} state={{ from: location }} replace />;

  if (isLoading) return <LinearProgress sx={{ mx: { xs: '2vh', lg: 25 }, mt: { xs: '40vh', lg: 'auto' } }} />;

  if (!element) return <Navigate to="/app" state={{ from: location }} replace />;

  if (!hasAccess) return <Navigate to="/404" state={{ from: location }} replace />;

  return element;
}

export default RequireAuth;

RequireAuth.propTypes = {
  element: PropTypes.element,
};
